import { formatCurrency } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValueChangedEvent } from 'devextreme/ui/lookup';
import { firstValueFrom } from 'rxjs';
import { Batch, BatchExpense, Currency, EMasterState, Organization, ProductBatch } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { BatchExpensesAddComponent } from 'src/app/routes/mes/operative/batch-expenses/components/batch-expenses-add/batch-expenses-add.component';
import { BatchExpensesEditComponent } from 'src/app/routes/mes/operative/batch-expenses/components/batch-expenses-edit/batch-expenses-edit.component';
import { MasterApiService } from 'src/app/services/master-api.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
    selector: 'app-product-batch-expenses',
    templateUrl: './product-batch-expenses.component.html',
    styleUrl: './product-batch-expenses.component.sass',
    standalone: false
})
export class ProductBatchExpensesComponent implements OnInit {

  @Input() entity?: Batch;
  productBatchExpenses?: GenericResource<BatchExpense>;
  batchExpenseAdd = BatchExpensesAddComponent;
  organizationResource = this.api.resources.organization.organizations as GenericResource<Organization>;
  currency?: Currency;
  formatCurrency = formatCurrency;
  formatCurrencyTextBox = (value: number | null) => {
    if (value == null) {
      return '';
    }
    return formatCurrency(value, this.tr.currentLang, this.currency!.currencySymbol, this.currency!.code, `.${this.currency!.decimals}`);
  };

  constructor(private api: MasterApiService, private storage: StorageService, private tr: TranslateService){}

  async ngOnInit(): Promise<void> {
    this.currency = await this.storage.getCompanyCurrency();
    this.productBatchExpenses = this.api.resources.batchExpenses.contextualizeQueryParams({ 'productBatchId': this.entity!.id.toString() }).asMappedResource({from: async(data) => {
      return {
        ...data,
        companyId: this.api.auth.userValue!.lastCompanyId
      }
    }}) as GenericResource<BatchExpense>;
  }

  updateOrganization(data: any, e: ValueChangedEvent) { 
    const value = e.value;
    data.setValue(value, value);
    
  }

}
